<template lang="pug">
  .loading.text-center

    //- bar chart
    svg(v-if='loadingType === LOADING_TYPE_BAR', xmlns="http://www.w3.org/2000/svg", xmlns:xlink="http://www.w3.org/1999/xlink", style="margin: auto; background: rgb(255, 255, 255); display: block; shape-rendering: auto;" :width='iconSize', :height='iconSize' viewBox="0 0 100 100" preserveAspectRatio="xMidYMid")
      g(transform="rotate(180 50 50)")
        rect(x="15" y="15" width="10" height="40" fill="#abbd81")
          animate(attributeName="height" values="50;70;30;50" keyTimes="0;0.33;0.66;1" dur="1s" repeatCount="indefinite" calcMode="spline" keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1" begin="-0.4s")
        rect(x="35" y="15" width="10" height="40" fill="#f8b26a")
          animate(attributeName="height" values="50;70;30;50" keyTimes="0;0.33;0.66;1" dur="1s" repeatCount="indefinite" calcMode="spline" keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1" begin="-0.2s")
        rect(x="55" y="15" width="10" height="40" fill="#f47e60")
          animate(attributeName="height" values="50;70;30;50" keyTimes="0;0.33;0.66;1" dur="1s" repeatCount="indefinite" calcMode="spline" keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1" begin="-0.6s")
        rect(x="75" y="15" width="10" height="40" fill="#e15b64")
          animate(attributeName="height" values="50;70;30;50" keyTimes="0;0.33;0.66;1" dur="1s" repeatCount="indefinite" calcMode="spline" keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1" begin="-1s")

    //- ghost
    svg(v-else-if='loadingType === LOADING_TYPE_GHOST', xmlns="http://www.w3.org/2000/svg", xmlns:xlink="http://www.w3.org/1999/xlink", style="margin:auto;background:transparent;display:block;", :width='iconSize', :height='iconSize', viewBox="0 0 100 100", preserveAspectRatio="xMidYMid")
      g(transform="translate(50 50)")
        g(transform="scale(1 -1)")
          g(transform="translate(-50 -50)")
            g
              animateTransform(attributeName="transform" type="rotate" values="-2 50 50;359 50 50" keyTimes="0;1" dur="1s" repeatCount="indefinite" calcMode="spline" keySplines="0.5 0 0.5 1")
              circle(cx="50" cy="50" r="39.891" stroke="#f9ae5c" stroke-width="14.4" fill="none" stroke-dasharray="0 300")
                animate(attributeName="stroke-dasharray" values="10 300;60.15421082128821 300;4 300" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite" calcMode="linear" keySplines="0 1 1 0;0 1 1 0")
              circle(cx="50" cy="50" r="39.891" stroke="#f9ae5c" stroke-width="7.2" fill="none" stroke-dasharray="0 300")
                animate(attributeName="stroke-dasharray" values="10 300;60.15421082128821 300;4 300" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite" calcMode="linear" keySplines="0 1 1 0;0 1 1 0")
              circle(cx="50" cy="50" r="32.771" stroke="#000000" stroke-width="1" fill="none" stroke-dasharray="0 300")
                animate(attributeName="stroke-dasharray" values="10 300;49.41750376837973 300;4 300" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite" calcMode="linear" keySplines="0 1 1 0;0 1 1 0")
              circle(cx="50" cy="50" r="47.171" stroke="#000000" stroke-width="1" fill="none" stroke-dasharray="0 300")
                animate(attributeName="stroke-dasharray" values="10 300;72.03697087422624 300;4 300" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite" calcMode="linear" keySplines="0 1 1 0;0 1 1 0")
      g
        animateTransform(attributeName="transform" type="rotate" values="360 50 50;0 50 50" keyTimes="0;1" dur="1s" repeatCount="indefinite" calcMode="spline" keySplines="0.5 0 0.5 1")
        path(fill="#f9ae5c" stroke="#000000" d="M82.8,50c0,0.9,0.7,2.6,1.8,3.7c0.3,0.3,0.8,0.6,1,1c0.2,0.5,0.2,1-0.1,1.5c-0.3,0.5-0.8,0.9-1.1,1.3 c-0.5,0.5-0.8,1.1-0.9,1.7c-0.2,0.6-0.2,1.2,0.2,1.8c0.6,1,2,1.7,2,2.8c-0.1,0.9-1,1.5-1.4,2.2c-0.3,0.6-0.4,1.2-0.2,1.9 c0.2,0.7,0.5,1.3,1,1.8c1,1,2.4,1.4,3.9,1.5c-1.1-1-1.2-2.7-0.5-4c0.7-1.2,2.2-1.9,2.5-3.3c0.2-1.2-0.4-2.5,0.1-3.6 c0.7-1.5,3.3-1.3,4.1-2.9c0.3-0.9,0-1.9,0.3-2.8c0.2-0.7,0.6-1.1,1-1.5c0.4-0.4,0.8-0.9,0.9-1.6c0.1-0.5,0.1-0.9,0.1-1.6")
      g
        animateTransform(attributeName="transform" type="rotate" values="360 50 50;0 50 50" keyTimes="0;1" dur="1s" repeatCount="indefinite" calcMode="spline" keySplines="0.5 0 0.5 1" begin="-0.1s")
        path(fill="#f9ae5c" stroke="#000000" d="M82.8,50c-0.1-3.1-0.4-6.2-1.3-9.2c-0.1-0.4-0.2-0.8-0.2-1.2c-0.1-0.4-0.1-0.8,0-1.2c0.1-0.8,0.3-1.6,0.7-2.4 c0.8-1.5,2-3,3.8-3.9l0,0c1.8-0.9,3.8-1,5.6-0.2c0.9,0.4,1.7,1,2.4,1.8c0.3,0.4,0.7,0.8,1,1.3c0.2,0.5,0.4,1,0.6,1.6 c1.4,4.3,1.9,8.8,1.9,13.3")
        path(fill="#ff7bac" d="M93.6,35.5c0.1,0.4-0.3,0.8-1,1c-0.6,0.2-1.2,0.1-1.3-0.3c-0.1-0.3,0.3-0.8,0.9-1S93.5,35.1,93.6,35.5z")
        path(fill="#ff7bac" d="M82.3,39.3c0.1,0.3,0.6,0.3,1.3,0.1c0.6-0.2,1.1-0.6,1-0.9c-0.1-0.3-0.7-0.3-1.3-0.1 C82.6,38.6,82.2,39,82.3,39.3z")
        path(fill="#000000" d="M88.9,37.5c0.1,0.3-0.2,0.7-0.7,0.8c-0.5,0.1-0.9,0-1-0.3c-0.1-0.3,0.2-0.7,0.7-0.8C88.4,37,88.9,37.2,88.9,37.5z")
        path(fill="none" stroke="#000000" d="M86.2,39.6c0.2,0.6,0.8,0.9,1.4,0.7c0.6-0.2,0.9-0.9,0.6-2.1c0.3,1.2,1,1.7,1.6,1.5c0.6-0.2,1-0.8,0.8-1.4")
        path(fill="#f9ae5c" stroke="#000000" d="M82.5,45.9c0,0.5,0.1,0.9,0.5,1.3c0.4,0.4,1,0.6,1.6,0.3c0.3-0.1,0.5-0.3,0.7-0.4c0.5-0.2,1.2,0.1,1.5,0.6 c0.3,0.5,0.3,1,0.3,1.6c0.6-0.6,1-1.4,1.3-2.2c0.2-0.7,0.4-1.5,0.2-2.2c-0.2-0.7-0.8-1.3-1.5-1.5c-0.9-0.2-1.8,0.2-2.5,0.7")
        path(fill="#f9ae5c" stroke="#000000" d="M96.8,44.1c0.1,0.7,0.1,1.4-0.2,2c-0.3,0.6-0.9,1-1.5,0.7c-0.3-0.1-0.5-0.4-0.8-0.4c-0.6-0.2-1.2,0.3-1.4,0.9 c-0.2,0.6-0.1,1.2-0.1,1.9c-0.6-0.7-1.2-1.5-1.6-2.3c-0.4-0.7-0.6-1.5-0.6-2.2c0-0.8,0.3-1.6,0.9-2c0.7-0.5,1.7-0.5,2.6-0.1")
        path(fill="#b5b5b5" d="M85.3,37.2c0.1,0.3,1.2,0.2,2.5-0.3c1.3-0.4,2.2-1.1,2.1-1.4c-0.1-0.3-1.2-0.2-2.5,0.3 C86.1,36.3,85.2,36.9,85.3,37.2z")
        path(fill="#000000" d="M91.5,35c0.3,0.7,0,1.4-0.7,1.6c-0.6,0.2-1.3-0.1-1.6-0.8c-0.2-0.6,0.1-1.3,0.7-1.6C90.6,33.9,91.3,34.3,91.5,35z")
        path(fill="#000000" d="M85.9,37c0.2,0.6-0.1,1.2-0.7,1.4c-0.6,0.2-1.3-0.1-1.5-0.6c-0.2-0.5,0.1-1.2,0.7-1.4C85,36.2,85.7,36.4,85.9,37z")
        path(fill="none" stroke="#000000" d="M89.7,29c0.4,0.7-1.4,2.2-3.8,3.4c-2.5,1.2-4.7,1.7-4.9,1.2c-0.3-0.5,1.4-2,3.8-3.4S89.4,28.4,89.7,29z")

    //- magnifying glass
    svg(v-else-if='loadingType === LOADING_TYPE_SEARCH', xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin:auto;background:#fff;display:block;" :width='iconSize', :height='iconSize' viewBox="0 0 100 100" preserveAspectRatio="xMidYMid")
      g(transform="translate(50 50)")
        g(transform="scale(0.8)")
          g(transform="translate(-50 -50)")
            g
              animateTransform(attributeName="transform" type="translate" repeatCount="indefinite" dur="1.25s" values="-20 -20;20 -20;0 20;-20 -20" keyTimes="0;0.33;0.66;1")
              path(fill="#bef6fd" d="M44.19 26.158c-4.817 0-9.345 1.876-12.751 5.282c-3.406 3.406-5.282 7.934-5.282 12.751 c0 4.817 1.876 9.345 5.282 12.751c3.406 3.406 7.934 5.282 12.751 5.282s9.345-1.876 12.751-5.282 c3.406-3.406 5.282-7.934 5.282-12.751c0-4.817-1.876-9.345-5.282-12.751C53.536 28.033 49.007 26.158 44.19 26.158z")
              path(fill="#f7d57f" d="M78.712 72.492L67.593 61.373l-3.475-3.475c1.621-2.352 2.779-4.926 3.475-7.596c1.044-4.008 1.044-8.23 0-12.238 c-1.048-4.022-3.146-7.827-6.297-10.979C56.572 22.362 50.381 20 44.19 20C38 20 31.809 22.362 27.085 27.085 c-9.447 9.447-9.447 24.763 0 34.21C31.809 66.019 38 68.381 44.19 68.381c4.798 0 9.593-1.425 13.708-4.262l9.695 9.695 l4.899 4.899C73.351 79.571 74.476 80 75.602 80s2.251-0.429 3.11-1.288C80.429 76.994 80.429 74.209 78.712 72.492z M56.942 56.942 c-3.406 3.406-7.934 5.282-12.751 5.282s-9.345-1.876-12.751-5.282c-3.406-3.406-5.282-7.934-5.282-12.751 c0-4.817 1.876-9.345 5.282-12.751c3.406-3.406 7.934-5.282 12.751-5.282c4.817 0 9.345 1.876 12.751 5.282 c3.406 3.406 5.282 7.934 5.282 12.751C62.223 49.007 60.347 53.536 56.942 56.942z")

    //- pacman
    svg(v-else-if='loadingType === LOADING_TYPE_PACMAN', xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin:auto;background:#fff;display:block;" :width='iconSize' :height='iconSize' viewBox="0 0 100 100" preserveAspectRatio="xMidYMid")
      g
        circle(cx="60" cy="50" r="4" fill="#e15b64")
          animate(attributeName="cx" repeatCount="indefinite" dur="1s" values="95;35" keyTimes="0;1" begin="-0.67s")
          animate(attributeName="fill-opacity" repeatCount="indefinite" dur="1s" values="0;1;1" keyTimes="0;0.2;1" begin="-0.67s")
        circle(cx="60" cy="50" r="4" fill="#e15b64")
          animate(attributeName="cx" repeatCount="indefinite" dur="1s" values="95;35" keyTimes="0;1" begin="-0.33s")
          animate(attributeName="fill-opacity" repeatCount="indefinite" dur="1s" values="0;1;1" keyTimes="0;0.2;1" begin="-0.33s")
        circle(cx="60" cy="50" r="4" fill="#e15b64")
          animate(attributeName="cx" repeatCount="indefinite" dur="1s" values="95;35" keyTimes="0;1" begin="0s")
          animate(attributeName="fill-opacity" repeatCount="indefinite" dur="1s" values="0;1;1" keyTimes="0;0.2;1" begin="0s")
      g(transform="translate(-15 0)")
        path(d="M50 50L20 50A30 30 0 0 0 80 50Z" fill="#f8b26a" transform="rotate(90 50 50)")
        path(d="M50 50L20 50A30 30 0 0 0 80 50Z" fill="#f8b26a")
          animateTransform(attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;45 50 50;0 50 50" keyTimes="0;0.5;1")
        path(d="M50 50L20 50A30 30 0 0 1 80 50Z" fill="#f8b26a")
          animateTransform(attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;-45 50 50;0 50 50" keyTimes="0;0.5;1")

    //- leaves (fall)
    svg(v-else-if='loadingType === LOADING_TYPE_FALL_LEAVES', xmlns='http://www.w3.org/2000/svg', xmlns:xlink='http://www.w3.org/1999/xlink', style='margin:auto;background:#fff;display:block;', :width='iconSize', :height='iconSize', viewBox='0 0 100 100', preserveAspectRatio='xMidYMid')
      g(transform="translate(50,50) scale(1) translate(-50,-50)")
        g
          animateTransform(attributeName="transform" type="rotate" values="0 50 50;90 50 50" times="0;1" dur="1s" repeatCount="indefinite")
          path(d="M44.6,20.6c2.6,4.4,7,7.1,11.7,7.7c1.9-4.4,1.7-9.5-0.8-14c-2.6-4.4-7-7.1-11.7-7.7C41.9,11,42,16.2,44.6,20.6z" fill="#e15b64" transform="rotate(0 50 50)")
            animate(attributeName="fill" repeatCount="indefinite" dur="1s" keyTimes="0;0.33;0.66;1" values="#e15b64;#f47e60;#f8b26a;#abbd81" begin="0s")
          path(d="M44.6,20.6c2.6,4.4,7,7.1,11.7,7.7c1.9-4.4,1.7-9.5-0.8-14c-2.6-4.4-7-7.1-11.7-7.7C41.9,11,42,16.2,44.6,20.6z" fill="#f47e60" transform="rotate(30 50 50)")
            animate(attributeName="fill" repeatCount="indefinite" dur="1s" keyTimes="0;0.33;0.66;1" values="#f47e60;#f8b26a;#abbd81;#e15b64" begin="0s")
          path(d="M44.6,20.6c2.6,4.4,7,7.1,11.7,7.7c1.9-4.4,1.7-9.5-0.8-14c-2.6-4.4-7-7.1-11.7-7.7C41.9,11,42,16.2,44.6,20.6z" fill="#f8b26a" transform="rotate(60 50 50)")
            animate(attributeName="fill" repeatCount="indefinite" dur="1s" keyTimes="0;0.33;0.66;1" values="#f8b26a;#abbd81;#e15b64;#f47e60" begin="0s")
          path(d="M44.6,20.6c2.6,4.4,7,7.1,11.7,7.7c1.9-4.4,1.7-9.5-0.8-14c-2.6-4.4-7-7.1-11.7-7.7C41.9,11,42,16.2,44.6,20.6z" fill="#abbd81" transform="rotate(90 50 50)")
            animate(attributeName="fill" repeatCount="indefinite" dur="1s" keyTimes="0;0.33;0.66;1" values="#abbd81;#e15b64;#f47e60;#f8b26a" begin="0s")
          path(d="M44.6,20.6c2.6,4.4,7,7.1,11.7,7.7c1.9-4.4,1.7-9.5-0.8-14c-2.6-4.4-7-7.1-11.7-7.7C41.9,11,42,16.2,44.6,20.6z" fill="#e15b64" transform="rotate(120 50 50)")
            animate(attributeName="fill" repeatCount="indefinite" dur="1s" keyTimes="0;0.33;0.66;1" values="#e15b64;#f47e60;#f8b26a;#abbd81" begin="0s")
          path(d="M44.6,20.6c2.6,4.4,7,7.1,11.7,7.7c1.9-4.4,1.7-9.5-0.8-14c-2.6-4.4-7-7.1-11.7-7.7C41.9,11,42,16.2,44.6,20.6z" fill="#f47e60" transform="rotate(150 50 50)")
            animate(attributeName="fill" repeatCount="indefinite" dur="1s" keyTimes="0;0.33;0.66;1" values="#f47e60;#f8b26a;#abbd81;#e15b64" begin="0s")
          path(d="M44.6,20.6c2.6,4.4,7,7.1,11.7,7.7c1.9-4.4,1.7-9.5-0.8-14c-2.6-4.4-7-7.1-11.7-7.7C41.9,11,42,16.2,44.6,20.6z" fill="#f8b26a" transform="rotate(180 50 50)")
            animate(attributeName="fill" repeatCount="indefinite" dur="1s" keyTimes="0;0.33;0.66;1" values="#f8b26a;#abbd81;#e15b64;#f47e60" begin="0s")
          path(d="M44.6,20.6c2.6,4.4,7,7.1,11.7,7.7c1.9-4.4,1.7-9.5-0.8-14c-2.6-4.4-7-7.1-11.7-7.7C41.9,11,42,16.2,44.6,20.6z" fill="#abbd81" transform="rotate(210 50 50)")
            animate(attributeName="fill" repeatCount="indefinite" dur="1s" keyTimes="0;0.33;0.66;1" values="#abbd81;#e15b64;#f47e60;#f8b26a" begin="0s")
          path(d="M44.6,20.6c2.6,4.4,7,7.1,11.7,7.7c1.9-4.4,1.7-9.5-0.8-14c-2.6-4.4-7-7.1-11.7-7.7C41.9,11,42,16.2,44.6,20.6z" fill="#e15b64" transform="rotate(240 50 50)")
            animate(attributeName="fill" repeatCount="indefinite" dur="1s" keyTimes="0;0.33;0.66;1" values="#e15b64;#f47e60;#f8b26a;#abbd81" begin="0s")
          path(d="M44.6,20.6c2.6,4.4,7,7.1,11.7,7.7c1.9-4.4,1.7-9.5-0.8-14c-2.6-4.4-7-7.1-11.7-7.7C41.9,11,42,16.2,44.6,20.6z" fill="#f47e60" transform="rotate(270 50 50)")
            animate(attributeName="fill" repeatCount="indefinite" dur="1s" keyTimes="0;0.33;0.66;1" values="#f47e60;#f8b26a;#abbd81;#e15b64" begin="0s")
          path(d="M44.6,20.6c2.6,4.4,7,7.1,11.7,7.7c1.9-4.4,1.7-9.5-0.8-14c-2.6-4.4-7-7.1-11.7-7.7C41.9,11,42,16.2,44.6,20.6z" fill="#f8b26a" transform="rotate(300 50 50)")
            animate(attributeName="fill" repeatCount="indefinite" dur="1s" keyTimes="0;0.33;0.66;1" values="#f8b26a;#abbd81;#e15b64;#f47e60" begin="0s")
          path(d="M44.6,20.6c2.6,4.4,7,7.1,11.7,7.7c1.9-4.4,1.7-9.5-0.8-14c-2.6-4.4-7-7.1-11.7-7.7C41.9,11,42,16.2,44.6,20.6z" fill="#abbd81" transform="rotate(330 50 50)")
            animate(attributeName="fill" repeatCount="indefinite" dur="1s" keyTimes="0;0.33;0.66;1" values="#abbd81;#e15b64;#f47e60;#f8b26a" begin="0s")

    //- snowflake
    div(v-else-if='loadingType === LOADING_TYPE_SNOWFLAKE')
      svg(xml:space="preserve" viewBox="0 0 100 100" y="0" x="0" xmlns="http://www.w3.org/2000/svg" version="1.1" :width='iconSize', :height='iconSize')
        g.ldl-scale(style="transform-origin: 50% 50%; transform: rotate(0deg) scale(0.8, 0.8);")
          g.ldl-ani
            g.ldl-layer
              g.ldl-ani(style="transform: scale(0.91); transform-origin: 50px 50px; animation: 1.11111s linear -0.694444s infinite normal forwards running breath-irapo;")
                path(fill="#a0c8d7" d="M52 77.6V22.4l9.4-9.4c.8-.8.8-2.1 0-2.9-.8-.8-2.1-.8-2.9 0L52 16.6V7.5c0-1.1-.9-2-2-2s-2 .9-2 2v9.1l-6.5-6.5c-.8-.8-2.1-.8-2.9 0-.8.8-.8 2.1 0 2.9l9.4 9.4v55.2L38.6 87c-.8.8-.8 2.1 0 2.9.4.4.9.6 1.4.6s1-.2 1.4-.6l6.5-6.5v9.1c0 1.1.9 2 2 2s2-.9 2-2v-9.1l6.5 6.5c.4.4.9.6 1.4.6s1-.2 1.4-.6c.8-.8.8-2.1 0-2.9L52 77.6z" style="fill: rgb(160, 200, 215);")
            g.ldl-layer
              g.ldl-ani(style="transform: scale(0.91); transform-origin: 50px 50px; animation: 1.11111s linear -0.833333s infinite normal forwards running breath-irapo;")
                path(fill="#a0c8d7" d="M90.2 60c-.3-1.1-1.4-1.7-2.5-1.4L74.9 62 51 48.2 27.1 34.4l-3.4-12.8c-.3-1.1-1.4-1.7-2.5-1.4-1.1.3-1.7 1.4-1.4 2.5l2.4 8.8-8-4.5c-1-.6-2.2-.2-2.8.7-.6 1-.2 2.2.8 2.8l7.9 4.6-8.8 2.4c-1.1.3-1.7 1.4-1.4 2.5.2.9 1.1 1.5 2 1.5.2 0 .4 0 .5-.1L25.1 38 49 51.8l23.9 13.8 3.4 12.8c.2.9 1.1 1.5 2 1.5.2 0 .4 0 .5-.1 1.1-.3 1.7-1.4 1.4-2.5l-2.4-8.8 7.9 4.6c.3.2.7.3 1 .3.7 0 1.4-.4 1.8-1 .6-1 .2-2.2-.8-2.8L79.8 65l8.8-2.4c1.2-.4 1.9-1.5 1.6-2.6z" style="fill: rgb(160, 200, 215);")
            g.ldl-layer
              g.ldl-ani(style="transform: scale(0.91); transform-origin: 50px 50px; animation: 1.11111s linear -0.972222s infinite normal forwards running breath-irapo;")
                path(fill="#a0c8d7" d="M88.7 37.5l-8.8-2.4 7.9-4.6c1-.6 1.3-1.8.8-2.8-.6-1-1.8-1.3-2.8-.7l-7.9 4.6 2.4-8.8c.3-1.1-.4-2.2-1.4-2.5-1.1-.3-2.2.4-2.5 1.4L73 34.5 49 48.2 25.1 62l-12.8-3.4c-1.1-.3-2.2.4-2.5 1.4-.3 1.1.4 2.2 1.4 2.5l8.8 2.4-7.9 4.6c-1 .6-1.3 1.8-.8 2.8.4.7 1.1 1 1.8 1 .3 0 .7-.1 1-.3l7.9-4.6-2.4 8.8c-.3 1.1.4 2.2 1.4 2.5.2 0 .4.1.5.1.9 0 1.7-.6 2-1.5l3.4-12.8L51 51.8 74.9 38l12.8 3.4c.2 0 .4.1.5.1.9 0 1.7-.6 2-1.5.3-1.1-.4-2.2-1.5-2.5z" style="fill: rgb(160, 200, 215);")
          g.ldl-layer
            g.ldl-ani
              g
                g.ldl-layer
                  g.ldl-ani(style="transform: scale(0.91); transform-origin: 50px 50px; animation: 1.11111s linear -1.11111s infinite normal forwards running breath-irapo;")
                    path(fill="#77a4bd" d="M62.9 72.4L50 64.9l-12.9 7.4V57.4L24.2 50l12.9-7.5V27.6L50 35.1l12.9-7.4v14.9L75.8 50l-12.9 7.5v14.9zM50 60.2l8.8 5.1V55.1l8.8-5.1-8.8-5.1V34.7L50 39.8l-8.8-5.1v10.2L32.4 50l8.8 5.1v10.2l8.8-5.1z" style="fill: rgb(119, 164, 189);")
      component#breath-irapo(is="style", data-anikit="", scoped)
        | @keyframes breath-irapo {
        |   0% {
        |     animation-timing-function: cubic-bezier(0.9647,0.2413,-0.0705,0.7911);
        |     transform: scale(0.87);
        |   }
        |   51% {
        |     animation-timing-function: cubic-bezier(0.9226,0.2631,-0.0308,0.7628);
        |     transform: scale(1.0698999999999999);
        |   }
        |   100% {
        |     transform: scale(0.87);
        |   }
        | }

    //- regular spinner
    font-awesome-icon.mx-1(v-else, :icon='["fas", "spinner"]', spin, :size='defaultSpinnerSize')

    .message.mt-2(v-if='showMessages') {{ messageToShow }}
    .message.text-danger.mt-2(v-if='showRefreshMessage') {{ refreshMessage }}
</template>

<script>
import { includes } from 'lodash';
import { DateTime } from 'luxon';

const _ = { includes };
const TIME_INTERVAL = 10000; // every 10 seconds
const MAX_TIME = 300000; // (5 min) when to show the error message that it probably timed out

const MONTH_OCTOBER = 10;
const MONTH_NOVEMBER = 11;
const MONTH_DECEMBER = 12;

export default {
  name: 'Loading',
  props: {
    messages: {
      type: Array,
      default: null
    },
    showMessages: {
      type: Boolean,
      default: false
    },
    refreshMessage: {
      type: String,
      default: 'This is taking awhile... there might be an issue with the server communication, try refreshing your browser'
    },
    type: String,
    size: String
  },
  data: () => ({
    LOADING_TYPE_BAR: 'bar',
    LOADING_TYPE_GHOST: 'ghost',
    LOADING_TYPE_SEARCH: 'search',
    LOADING_TYPE_PACMAN: 'pacman',
    LOADING_TYPE_FALL_LEAVES: 'fall_leaves',
    LOADING_TYPE_SNOWFLAKE: 'snowflake',

    currentTimer: null,
    defaultMessages: [
      'Loading...',
      'Arranging the bits to get your data...',
      'Computing your query...',
      'Crunching the numbers...',
      'Assembling your report...'
    ],
    selectedMessage: 0,
    totalTime: 0
  }),
  computed: {
    availableMessages: function () {
      return this.messages ? this.messages : this.defaultMessages;
    },
    messageToShow: function () {
      return this.availableMessages[this.selectedMessage];
    },
    showRefreshMessage: function () {
      return this.totalTime >= MAX_TIME;
    },
    validLoadingTypes: function () {
      return [
        this.LOADING_TYPE_BAR,
        this.LOADING_TYPE_GHOST,
        this.LOADING_TYPE_SEARCH,
        this.LOADING_TYPE_PACMAN,
        this.LOADING_TYPE_FALL_LEAVES,
        this.LOADING_TYPE_SNOWFLAKE
      ];
    },
    loadingType: function () {
      let defaultType = null;
      const currentMonth = DateTime.now().toUTC().month;

      if (currentMonth === MONTH_OCTOBER) {
        defaultType = this.LOADING_TYPE_GHOST;
      }
      else if (currentMonth === MONTH_NOVEMBER) {
        defaultType = this.LOADING_TYPE_FALL_LEAVES;
      }
      else if (currentMonth === MONTH_DECEMBER) {
        defaultType = this.LOADING_TYPE_SNOWFLAKE;
      }
      return _.includes(this.validLoadingTypes, this.type) ? this.type : defaultType;
    },
    iconSize: function () {
      return this.size ? `${this.size}px` : '100px';
    },
    defaultSpinnerSize: function () {
      return this.size || '3x';
    }
  },
  methods: {
    getNewMessage() {
      this.currentTimer = null;
      this.selectMessage();
      this.totalTime += TIME_INTERVAL;

      // schedule it again
      this.currentTimer = setTimeout(this.getNewMessage, TIME_INTERVAL);
    },
    selectMessage() {
      this.selectedMessage = Math.floor(Math.random() * Math.floor(this.availableMessages.length));
    }
  },
  created: function () {
    this.currentTimer = setTimeout(this.getNewMessage, TIME_INTERVAL);
  },
  beforeDestroy: function () {
    if (this.currentTimer) {
      clearTimeout(this.currentTimer);
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
</style>
